var map = {
	"./3x3basketball-dark.svg": "88e7",
	"./all-sports-dark.svg": "5b20",
	"./americanfootball-dark.svg": "a924",
	"./aussie-rules-dark.svg": "e7de",
	"./australianrules-dark.svg": "efbf",
	"./badminton-dark.svg": "a100",
	"./baseball-dark.svg": "078a",
	"./basketball-dark.svg": "63c5",
	"./beachvolleyball-dark.svg": "cd62",
	"./bowls-dark.svg": "d6b5",
	"./boxing-dark.svg": "880f",
	"./cricket-dark.svg": "55c7",
	"./darts-dark.svg": "5d91",
	"./esports-dark.svg": "2249",
	"./football-dark.svg": "6c2e",
	"./formulaone-dark.svg": "ed7a",
	"./futsal-dark.svg": "7d84",
	"./gaelicfootball-dark.svg": "e0a4",
	"./handball-dark.svg": "3d9f",
	"./hockey-dark.svg": "9bf1",
	"./horse-racing-dark.svg": "51e1",
	"./hurling-dark.svg": "d82b",
	"./icehockey-dark.svg": "26eb",
	"./mixedmartialarts-dark.svg": "fe39",
	"./motorsport-dark.svg": "6a3c",
	"./pickleball-dark.svg": "fc16",
	"./rugby-dark.svg": "6f68",
	"./rugbyleague-dark.svg": "cfe6",
	"./rugbyunion-dark.svg": "0f46",
	"./snooker-dark.svg": "352a",
	"./soccer-dark.svg": "f1c9",
	"./squash-dark.svg": "7bf0",
	"./streamingevents-dark.svg": "aef0",
	"./streamingtab-dark.svg": "a635",
	"./tabletennis-dark.svg": "f40f",
	"./tennis-dark.svg": "403e",
	"./tennisdoubles-dark.svg": "a781",
	"./testcricket-dark.svg": "6823",
	"./volleyball-dark.svg": "6566",
	"./waterpolo-dark.svg": "da06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9620";